export const KEY_CODES = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
} as const;
